import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS,
	POST_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS_PACKING_BATCH
} from "@apis/apiPath";

export const useMemberOrderApi = () => {
	const Ajax = useAjax();
	// 來店欠款畫面
	const getMemberOverduePaymentApi = useCallback(
		async memberID => {
			return await Ajax.get(GET_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS(memberID));
		},
		// eslint-disable-next-line
		[]
	);

	// 智能系統欠款訂單再次打包送出
	const postMemberDeviceOrderPackingBatch = useCallback(async (memberID) => {
			return await Ajax.post(POST_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS_PACKING_BATCH(memberID))
		},
		// eslint-disable-next-line
		[]);

	return {
		getMemberOverduePaymentApi,
		postMemberDeviceOrderPackingBatch,
	};
};
